import { ROUTES } from '@/constants/routes';

const PATH_TO_STEP: Record<string, string> = {
  [ROUTES.STANDARDISIERUNG]: 'standardization',
  [ROUTES.ZEITRASTEREINSTELLUNG]: 'time-grid-setting',
  [ROUTES.ANOMALIEERKENNUNG]: 'anomaly-detection',
  [ROUTES.DATA_ADJUSTMENTS]: 'data-adjustments',
  [ROUTES.DATENWOLKE]: 'data-cloud',
  [ROUTES.CSV_FILTER]: 'data-filter',
  [ROUTES.TRAINING]: 'training',
  [ROUTES.FORECAST_API]: 'forecast-api',
};

/** Map a tool route to a step name the assistant understands; null elsewhere. */
export function stepFromPath(pathname: string): string | null {
  return PATH_TO_STEP[pathname] ?? null;
}
